import React, { FC, useMemo } from 'react';

import { EvFilters, OptionType } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';

import { useWebSdkTestsFilters } from '../../hooks/useWebSdkTestsFilters';

import { FilterSectionCommon } from './shared/FilterSectionCommon';
import { useFilterApplyHandler } from './shared/useFilterApplyHandler';

interface FilterSectionProps {
	isFilterOptionsLoading: boolean;
	filterOptions: {
		labels: OptionType[];
		properties: OptionType[];
		testPeriod: OptionType[];
	};
	filters?: IFilterOptions;
	showRecentTest: boolean;
	onShowRecentTestChange: () => void;
	showTestPath: boolean;
}

export const FilterSection: FC<FilterSectionProps> = ({
	isFilterOptionsLoading,
	filterOptions,
	filters,
	showRecentTest,
	onShowRecentTestChange,
	showTestPath
}) => {
	const { handleApply } = useFilterApplyHandler({ filterOptionsType: 'v1' });

	const initialValues = useMemo(
		() => ({
			text: { searchValue: filters?.searchValue },
			select: omit(filters, 'searchValue')
		}),
		[filters]
	);

	// Use shared hook for async loading and filter definitions
	const { filterDefinitions, mergedFilterOptions } = useWebSdkTestsFilters({
		allLabels: filterOptions.labels,
		selectedLabels: filters?.labels ?? [],
		filterOptions,
		isV2: false
	});

	return (
		<FilterSectionCommon
			isFilterOptionsLoading={isFilterOptionsLoading}
			showRecentTest={showRecentTest}
			onShowRecentTestChange={onShowRecentTestChange}
			showTestPath={showTestPath}
		>
			<EvFilters
				className="data-filters"
				onApply={handleApply}
				onReset={handleApply}
				initialValues={initialValues}
				isFilterOptionsLoaded={!isFilterOptionsLoading}
				filterOptions={mergedFilterOptions}
				filterDefinitions={filterDefinitions}
				shouldSyncValuesWithAvailableOptions={false}
			/>
		</FilterSectionCommon>
	);
};
